import { FaExclamationTriangle, FaRedo, FaHome } from "react-icons/fa";

const UnknownException = () => {
  const refreshPage = () => {
    window.location.reload();
  };

  const goHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 10 }}>
      <div className="w-4/5 max-w-2xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-orange-500"></div>
        <div className="absolute top-4 right-4 w-16 h-16 bg-orange-500 rounded-full opacity-20"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 bg-orange-500 rounded-full opacity-15"></div>
        
        {/* Error Icon */}
        <div className="relative z-10 mb-8">
          <div className="w-24 h-24 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaExclamationTriangle className="text-white text-4xl" />
          </div>
        </div>

        {/* Content */}
        <div className="relative z-10">
          <h2 className="text-3xl font-bold text-var(--text-color) mb-4">System Error</h2>
          <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
            Unfortunately, our system encountered an unexpected error. 
            This is a temporary issue and should be resolved shortly.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button 
              onClick={refreshPage}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center text-lg group"
            >
              <FaRedo className="mr-2 group-hover:rotate-180 transition-transform" />
              Try Again
            </button>
            <button 
              onClick={goHome}
              className="bg-[#FC532B] hover:bg-[#e04a26] text-white font-bold px-6 py-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center text-lg group"
            >
              <FaHome className="mr-2 group-hover:rotate-12 transition-transform" />
              Go Home
            </button>
          </div>

          {/* Additional Info */}
          <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
            <p className="text-sm text-var(--text-color) opacity-70">
              If the problem persists, please contact our technical support team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnknownException;
